import React from 'react'
import { PropertyTypes } from '@/components/PropertyTypes'

interface IProps {
  onChangePropertyType: (value: { property_type: string[] }) => void
  propertyTypes: string[]
}
export const PropertyTypesMainFilters = ({
  onChangePropertyType,
  propertyTypes
}: IProps) => {
  return (
    <div className="flex flex-col gap-4 p-4 rounded-xl border border-surface-strokes shadow-[0px_3px_34px_-2px_rgba(34,34,34,0.20)] bg-white max-h-[152px] overflow-y-auto">
      <PropertyTypes
        propertyTypes={propertyTypes}
        onChangePropertyType={onChangePropertyType}
        typesToShow={2}
      />
    </div>
  )
}
